import { PdpSharedRecentSales_item } from '../PdpSharedRecentSales/__generated__/PdpSharedRecentSales_item.graphql';

export const getDisplayPriceAmount = (
    displayPrice: PdpSharedRecentSales_item['displayPrice'],
    currency: string
): number | null => {
    const itemPriceDisplay = displayPrice?.[0];
    const priceAmount = (itemPriceDisplay?.convertedAmountList || []).find(
        convertedAmount => convertedAmount && convertedAmount.currency === currency
    );

    const price = (priceAmount && priceAmount.amount) || null;

    return price;
};
